import React from 'react';
import { ShieldIcon, ZapIcon, ClockIcon, HeartIcon } from 'lucide-react';
import { motion } from 'framer-motion';
const trustItems = [{
  icon: ShieldIcon,
  label: 'FDA-Cleared Device Class'
}, {
  icon: ZapIcon,
  label: 'Non-Hormonal'
}, {
  icon: ClockIcon,
  label: '10-Minute Protocol'
}, {
  icon: HeartIcon,
  label: '180-Day Guarantee'
}];
export function TrustBand() {
  return <div className="w-full border-t border-b border-[#2A2A2A] bg-[#111111]" data-id="element-459">
      <div className="max-w-6xl mx-auto px-6 py-5" data-id="element-460">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-6" data-id="element-461">
          {trustItems.map((item, i) => <motion.div key={item.label} initial={{
          opacity: 0,
          y: 10
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.4,
          delay: i * 0.1
        }} className="flex items-center gap-3 justify-center" data-id="element-462">
              <item.icon className="w-5 h-5 text-[#C8A04A] flex-shrink-0" data-id="element-463" />
              <span className="text-sm font-medium text-[#9CA3AF]" data-id="element-464">
                {item.label}
              </span>
            </motion.div>)}
        </div>
      </div>
    </div>;
}